import store from "../store/index";
//----------------
// set view round
//----------------
export default function setViewRound(round) {
  //----------------
  // set view round
  //----------------
  store.commit("combat/setViewRound", round);
}
